import { useEffect } from 'react'
import { AppNotification } from '@digital-twins/shared-types'
import {
  onNotificationNew,
  disconnectNotificationsSocket,
} from '@/lib/services/notifications-socket'

export function useNotificationsSocket(
  onNewNotification: (notification: AppNotification) => void,
) {
  useEffect(() => {
    const unsubscribe = onNotificationNew(onNewNotification)

    return () => {
      unsubscribe()
      disconnectNotificationsSocket()
    }
  }, [onNewNotification])
}
